import React from 'react';
import ktcLogo from '../assets/ktc.png';

const MapLoadingOverlay = ({ text = 'Memuat peta...' }) => {
  return (
    <div className="absolute inset-0 z-[1200] flex items-center justify-center bg-[#040913]/78 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-3 rounded-xl border border-cyan-300/35 bg-[#091120]/88 px-6 py-5 shadow-[0_0_28px_rgba(0,229,255,0.18)]">
        <img src={ktcLogo} alt="KTC" className="h-14 w-auto animate-pulse" />
        <div className="h-6 w-6 rounded-full border-2 border-cyan-300/30 border-t-cyan-300 animate-spin" />
        <p className="text-xs font-medium text-cyan-100/90">{text}</p>
      </div>
    </div>
  );
};

export default MapLoadingOverlay;

